import { render, staticRenderFns } from "./GrantEdit.vue?vue&type=template&id=78beefdd&"
import script from "./GrantEdit.vue?vue&type=script&lang=js&"
export * from "./GrantEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports